import { render, staticRenderFns } from "./OptimalPostsPlanning.vue?vue&type=template&id=3c76a9ea"
import script from "./OptimalPostsPlanning.vue?vue&type=script&lang=js"
export * from "./OptimalPostsPlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c76a9ea')) {
      api.createRecord('3c76a9ea', component.options)
    } else {
      api.reload('3c76a9ea', component.options)
    }
    module.hot.accept("./OptimalPostsPlanning.vue?vue&type=template&id=3c76a9ea", function () {
      api.rerender('3c76a9ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/OptimalPostsPlanning.vue"
export default component.exports